import { lazyRoute } from './utils/lazyRoute';
import { loadCameraData } from './data/cameraDataLazy';

// Route-level code splitting: each calculator loads as its own chunk instead
// of one 1.4 MB bundle. lazyRoute (vs plain React.lazy) lets index.js preload
// the current route's chunk before hydration so prerendered HTML hydrates
// cleanly — see utils/lazyRoute.js.
export const AspectRatioCalculator = lazyRoute('aspect-ratio', () => import('./components/AspectRatioCalculator'));
export const BitrateCalculator = lazyRoute('bitrate', () => import('./components/BitrateCalculator'));
export const CameraToFileSize = lazyRoute('camera', () => import('./components/CameraToFileSize'));
export const ComingSoon = lazyRoute('comingsoon', () => import('./components/ComingSoon'));
export const DailiesCalculator = lazyRoute('dailies', () => import('./components/DailiesCalculator'));
export const DurationToFileSize = lazyRoute('duration', () => import('./components/DurationToFileSize'));
export const FilmCalculator = lazyRoute('film', () => import('./components/FilmCalculator'));
export const TransferTimeCalculator = lazyRoute('transfer-time', () => import('./components/TransferTimeCalculator'));
export const TimecodeGraphingCalculator = lazyRoute('timecode', () => import('./components/TimecodeGraphingCalculator'));
export const FramingChartGenerator = lazyRoute('framing-chart', () => import('./components/FramingChartGenerator'));
export const AnalyticsDashboard = lazyRoute('analytics', () => import('./components/AnalyticsDashboard'));
export const CameraSpecsApp = lazyRoute('cameraspecs', () => import('./components/cameraspecs/CameraSpecsApp'));
export const SpecViewer = lazyRoute('cameraspecs-spec', () => import('./components/cameraspecs/SpecViewer'));
export const RequestPage = lazyRoute('request', () => import('./components/RequestPage'));

// Paths that were prerendered by react-snap (see package.json reactSnap.include)
// mapped to the chunk that must be loaded before hydration.
export const routePreloads = {
  '/duration': DurationToFileSize.preload,
  '/aspect-ratio': AspectRatioCalculator.preload,
  '/bitrate': BitrateCalculator.preload,
  // Camera-data routes also need the camera DB pre-hydration: their first
  // render seeds <option> lists synchronously via cameraDataLazy.
  '/camera': () => Promise.all([CameraToFileSize.preload(), loadCameraData()]),
  // Dailies also needs the camera DB loaded pre-hydration: CalculatorContext
  // seeds dailies dropdown options from it synchronously (cameraDataLazy).
  '/dailies': () => Promise.all([DailiesCalculator.preload(), loadCameraData()]),
  '/film': FilmCalculator.preload,
  '/timecode': TimecodeGraphingCalculator.preload,
  '/transfer-time': TransferTimeCalculator.preload,
  '/framing-chart': () => Promise.all([FramingChartGenerator.preload(), loadCameraData()]),
  '/request': RequestPage.preload,
};
